import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'
import Modal from 'react-bootstrap/lib/Modal'

import FIC from '../../../common/general/js/FIC'
import FICUtils from '../../../common/general/js/FICUtils'
import FICButton from '../FICButton/FICButton'

import './FICModal.less'

export var FICModalBody = Modal.Body
export var FICModalRawHeader = Modal.Header
export var FICModalRawTitle = Modal.Title
export var FICModalRawFooter = Modal.Footer

export default class FICModalV2 extends Component {
  constructor (props) {
    super(props)
    this.state = {
      _visible: 'pre-show'
    }
    this._mounted = true
    this._container = props.container
  }

  componentDidCatch (error, info) {
    if (FIC.browser && FIC.browser.name === 'ie' && FIC.browser.version < '11') { alert('Si è verificato un errore. Aggiorna il browser alla versione più recente.') }
  }

  componentDidMount () {
    setTimeout(() => {
      this.setState({ _visible: 'visible' }, () => {
        this.focus()
      })
    }, 0)
  }

  componentWillUnmount () {
    this._mounted = false
  }

  hideInBG = () => {
    this.setState({ _visible: 'hidden' })
  }
  showFromBG = () => {
    if (this.state._visible === 'hidden') {
      this.setState({ _visible: 'visible' }, () => {
        this.focus()
      })
    }
  }
  hide = () => { // Sarebbe close
    const id = this.props.id
    this.setState({ _visible: 'closed' }, () => {
      if (this._container) { this._container.remove(id) }
    })
  }
  focus = () => {
    setTimeout(() => {
      $('.fic-modal-' + this.props.id).focus()
    }, 10) // Delay necessario
  }
  renderChildren = (props) => {
    if (!this.props.children) return null
    return React.Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        hide: this.hide
      })
    })
  }

  render () {
    let style = { content: {} }
    if (this.props.width) {
      style.content.width = this.props.width
    }
    if (this.props.maxWidth) {
      style.content.maxWidth = this.props.maxWidth
    }
    let className = 'fic-modal fic-modal-' + this.props.id
    if (this.props.scrollable) {
      className += ' scrollable'
    }
    return <ReactModal
      id={this.props.id}
      className={className}
      overlayClassName={'FICModal2_Overlay fic-modal-' + this.state._visible}
      isOpen
      contentLabel='Finestra di dialogo'
      onHide={this.hide}
      style={style}
      onRequestClose={this.hide}
      tabindex='-1'
      ariaHideApp={false}>
      {this.renderChildren() || <div>
        <FICModalHeader html={this.props.htmlTitle} />
        <FICModalBody>{this.props.htmlBody}</FICModalBody>
        <FICModalFooter modal={this} html={this.props.htmlFooter} buttons={this.props.footerButtons} />
      </div>}
    </ReactModal>
  }
}

export class FICModalContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      propsStack: []
    }
    this.modalRefs = {}
  }

  add = (properties) => {
    this.setState((prevState) => {
      let newStack = prevState.propsStack.slice()
      const newId = new Date().getTime() + '-' + FICUtils.randomBetween(0, 10000)
      properties.id = newId
      for (let key in this.modalRefs) {
        if (!this.modalRefs.hasOwnProperty(key)) continue
        this.modalRefs[key].hideInBG()
      }
      newStack.push(properties)
      return { propsStack: newStack }
    })
  }
  remove = (id) => {
    delete this.modalRefs[id]
    setTimeout(() => {
      this.setState((prevState) => {
        let newStack = prevState.propsStack.slice()
        newStack = newStack.filter(item => item.id !== id)
        return { propsStack: newStack }
      })
    }, 500)
    if (Object.keys(this.modalRefs).length > 0) {
      let lastKey
      // do not change or you'll get fired
      // seriously
      for (lastKey in this.modalRefs) {
        // do nothing
      }
      this.modalRefs[lastKey].showFromBG()
    }
  }

  render () {
    return <div>{
      this.state.propsStack.map((item, idx) => {
        return <FICModalV2
          id={item.id}
          key={item.id}
          container={this}
          ref={(modal) => {
            if (modal && modal.state._visible !== 'closed') {
              this.modalRefs[item.id] = modal
            }
          }}
          {...item.props}>
          {item.content}
        </FICModalV2>
      })
    }</div>
  }
}

FICModalV2.init = (container) => {
  FICModalV2.container = ReactDOM.render(
    <FICModalContainer />,
    container
  )
}

/*

USAGE:

FICModal.show({
  title: "Ciao",
  body: "Miao",
  actions: [
    {text: "Conferma", color: "success", onClick: null},
    {text: "Chiudi", color: "gray", onClick: null},
  ]
})

*/

FICModalV2.show = (options) => {
  FICModalV2.container.add({
    content: null,
    props: {
      width: options.width,
      htmlTitle: options.title,
      htmlBody: options.body,
      htmlFooter: options.footer,
      footerButtons: options.actions
    }
  })
}

FICModalV2.showMessage = (title, message, smallMessage) => {
  FICModalV2.show({
    title: title,
    body: <span>
      {message}
      {smallMessage && <Fragment><br /><span className='small-gray-message'>{smallMessage}</span></Fragment>}
    </span>,
    actions: [
      { text: 'Chiudi', color: 'gray', onClick: null }
    ]
  })
}

/*

USAGE:

FICModal.showCustom(<Component/>, {propName: "Abc"})

*/

FICModalV2.showCustom = (content) => {
  FICModalV2.showCustom(content, null)
}

FICModalV2.showCustom = (content, modalProps) => {
  FICModalV2.container.add({ content: content, props: modalProps })
}

export function FICModalHeader (props) {
  return <FICModalRawHeader><FICModalRawTitle>{props.html}</FICModalRawTitle></FICModalRawHeader>
}

function itemsWithType (items, type) {
  if (!items) return []
  else return items.map(item => Object.assign(item, { type: type }))
}

export function FICModalFooter (props) {
  let footer = props.html
  const items = [
    ...itemsWithType(props.leftItems, 'left'),
    ...itemsWithType(props.centerItems, 'center'),
    ...itemsWithType([...props.rightItems, ...props.buttons].reverse(), 'right')
  ]
  if (items) {
    footer = items.map(({ hide, html, type, icon, onClick, keepOpen, ...item }, idx) => {
      if (hide) { return null }
      if (html) {
        return <div
          className={'footer-item ' + type}
          key={idx}
          style={{ display: 'inline-block', height: '31px' }}>{html}</div>
      }
      return <FICButton
        className={'footer-item ' + type}
        key={idx}
        iconLeft={icon}
        onClick={() => {
          if (onClick !== undefined) { onClick() }
          if (props.modal && !keepOpen) { props.modal.hide() }
        }}
        {...item}
      />
    })
  }
  return <FICModalRawFooter>{footer}</FICModalRawFooter>
}

FICModalFooter.propTypes = {
  leftItems: PropTypes.array,
  centerItems: PropTypes.array,
  rightItems: PropTypes.array,
  buttons: PropTypes.array
}

FICModalFooter.defaultProps = {
  leftItems: [],
  centerItems: [],
  rightItems: [],
  buttons: []
}

FICModalHeader.propTypes = {
  html: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

/*
Modal html sporco
 */
/*
modalUrl = (url, params = {}) => {
  $.get(url, (data) => {
    if (FICModalHtml.lastHideCallback)
      FICModalHtml.lastHideCallback()

    FICModal.showCustom(<FICModalHtml html={data}/>, params)
  })
}
*/

export class FICModalHtml extends Component {
  constructor (props) {
    super(props)
    this.body = null
    FICModalHtml.lastHideCallback = props.hide
  }

  componentDidMount () {
    $(this.body).html(this.props.html)
    $(this.body).find('a[data-dismiss=\'modal\']').click(() => {
      this.props.hide()
    })
  }

  render () {
    return (
      <div ref={element => this.body = element} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/common/components-v2/FICModal/FICModal.js